import * as React from 'react';
import styled from 'styled-components';

const DocumentalContentWrapper = styled.div`
  padding-left: 24px;
  .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export interface IDocumentalContentProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Riga di documenti o folder.
 */
export function DocumentalContent(props: IDocumentalContentProps) {
  return <DocumentalContentWrapper {...props} />;
}
